module.exports = __webpack_public_path__ + "static/media/tsc-cards.686fc3b0.png";